import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {HttpResponse} from '@angular/common/http';
import {AuthenticationService} from '../../sdk/service/authentication.service';
import {InvoiceType, MerchantInvoice, WebInvoiceService} from 'web-angular-client';
import * as FileSaver from 'file-saver';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {AlertService} from '../../sdk/service/alert.service';
import {ConfirmationService} from '../../sdk/service/confirmation.service';

@Component({
    selector: 'app-monthly-invoices',
    templateUrl: 'invoices.component.html',
    styleUrls: ['./invoices.component.scss'],
    standalone: false
})

export class InvoicesComponent implements OnInit
{
    invoices: MerchantInvoice[];
    @ViewChild('monthlyInvoicesTab') protected monthlyInvoicesTabElement: ElementRef;
    @ViewChild('invoicesTab') protected invoicesTabElement: ElementRef;
    private allInvoices: MerchantInvoice[];

    constructor(
        private authenticationService: AuthenticationService,
        private invoiceService: WebInvoiceService,
        private ngxLoader: NgxUiLoaderService,
        private alertService: AlertService,
        private confirmationService: ConfirmationService)
    {
    }

    private _activeTab: string = 'monthly-invoices-tab';

    get activeTab(): string
    {
        return this._activeTab;
    }

    ngOnInit(): void
    {
        this.invoiceService.getMerchantInvoices().subscribe((invoices: MerchantInvoice[]) =>
        {
            this.allInvoices = invoices;
            this.refreshInvoices(this._activeTab);
        });
    }

    isGuestAdminUser(): boolean
    {
        return this.authenticationService.isGuestAdminUser();
    }

    downloadInvoice(invoice: MerchantInvoice): void
    {
        this.ngxLoader.start();
        this.invoiceService.getInvoiceByInvoiceId(invoice.id, 'response').subscribe(
            (response: HttpResponse<Blob>) =>
            {
                FileSaver.saveAs(response.body, `${invoice.invoiceName}.pdf`);
                this.ngxLoader.stop();
                const pendingHeader = response.headers.get('X-Refund-Fees-Pending');
                if (pendingHeader !== null)
                {
                    invoice.refundFeesPending = pendingHeader === 'true';
                }
                if (pendingHeader === 'true')
                {
                    this.confirmationService.confirm(
                        'Refund fees pending',
                        'This invoice does not yet include refund fees still being finalised for this period. ' +
                            'It will be updated once they are.',
                        'OK',
                        'Cancel',
                        'sm',
                        true);
                }
            },
            (error) =>
            {
                this.ngxLoader.stop();
                this.alertService.error(error);
            });
    }

    refreshInvoices(tabId: string)
    {
        this._activeTab = tabId;
        if (tabId === this.monthlyInvoicesTabElement.nativeElement.id)
        {
            this.invoices = this.allInvoices.filter(i => i.invoiceType === InvoiceType.MONTHLY);
        }
        else
        {
            this.invoices = this.allInvoices.filter(i => i.invoiceType === InvoiceType.PREPAID);
        }
    }

    view(invoice: MerchantInvoice)
    {
        // not used but required to be implemented
    }
}